import React from 'react';
import PropTypes from 'prop-types';
import './EmptyState.css';

export function EmptyState({
  title = 'Nothing here',
  description,
  detail,
  action,
  centered = false,
  density = 'comfortable',
  className = '',
}) {
  return (
    <div
      className={[
        'onyx-empty-state',
        centered ? 'onyx-empty-state--centered' : '',
        density === 'compact' ? 'onyx-empty-state--compact' : '',
        className,
      ].filter(Boolean).join(' ')}
      data-testid="onyx-empty-state"
      data-density={density}
    >
      <h3 className="onyx-empty-state__title">{title}</h3>
      {description ? (
        <p className="onyx-empty-state__description">{description}</p>
      ) : null}
      {detail ? (
        <p className="onyx-empty-state__detail">{detail}</p>
      ) : null}
      {action ? <div className="onyx-empty-state__action">{action}</div> : null}
    </div>
  );
}

EmptyState.propTypes = {
  title: PropTypes.node,
  description: PropTypes.node,
  detail: PropTypes.node,
  action: PropTypes.node,
  centered: PropTypes.bool,
  density: PropTypes.oneOf(['comfortable', 'compact']),
  className: PropTypes.string,
};

export default EmptyState;
